import React from 'react'
import PropTypes from 'prop-types'

import NumberFormat from 'react-number-format'

const MoneyFormat = ({ value }) => (
  <NumberFormat
    thousandSeparator='.'
    decimalScale='2'
    decimalSeparator=','
    fixedDecimalScale
    prefix='R$ '
    displayType='text'
    value={value}
  />
)

MoneyFormat.propTypes = {
  value: PropTypes.number.isRequired,
}

export default MoneyFormat
